export const METER_READING_SOURCES = {
  CUSTOMER: 'CUSTOMER',
  OPS: 'OPS',
  METER_READER: 'METER_READER',
  ESTIMATE: 'ESTIMATE',
  SMART: 'SMART',
};

export const METER_READING_SOURCE_LABELS = {
  CUSTOMER: 'Your reading',
  OPS: 'Your reading',
  METER_READER: 'Our reading',
  NETWORK_TECHNICIAN: 'Our reading',
  ESTIMATE: 'Estimate',
  SMART: 'Smart', // TODO: use correct label for smart meter readings when we have clients with smart meters
};

export const LAST_READING_SOURCE_LABEL = {
  CUSTOMER: 'by you',
  OPS: 'by you',
  METER_READER: 'by us',
  ESTIMATE: '(estimate)',
  SMART: '(smart meter)',
  NETWORK_TECHNICIAN: 'by us',
};

export const DEFAULT_LAST_READING = {
  valueCubicMetres: 0,
  readingDate: new Date(),
};
